module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_0.189b56de.png";